import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "@/services/cloudchipr.api";

export const getInfrastructureArchitecturePossibleServicesThunk =
  createAsyncThunk(
    "infrastructureArchitecture/getInfrastructureArchitecturePossibleServices",
    async (_: void, { dispatch }) => {
      const { getUsersMeSolutionArchitectsPossibleResources } =
        cloudChiprApi.endpoints;

      try {
        return await dispatch(
          getUsersMeSolutionArchitectsPossibleResources.initiate({}),
        ).unwrap();
      } catch (e) {
        // @ts-expect-error todo: fix api spec;
        enqueueSnackbarErrorAlert(e?.data?.message);
      }
    },
  );
